import type { ScheduleGrid } from "features/transient-response/schedules/model/types";

export const ROOM_SCHEDULE_MODES = ["realistic", "din", "custom"] as const;

export type RoomScheduleMode = (typeof ROOM_SCHEDULE_MODES)[number];

export const ROOM_SCHEDULE_HEATMAP_KEYS = ["occupancy", "illuminance", "ventilation", "appliances"] as const;

export type RoomScheduleHeatmapKey = (typeof ROOM_SCHEDULE_HEATMAP_KEYS)[number];

export const ROOM_SCHEDULE_SUBTABS = ROOM_SCHEDULE_HEATMAP_KEYS;

export type RoomScheduleApiItem = {
  data?: null | RoomScheduleMatrix;
  type: RoomScheduleApiType;
};

export type RoomScheduleApiType = "Customized" | "DIN" | "realistic";

export type RoomScheduleHeatmapState = {
  customGrid: ScheduleGrid;
  mode: RoomScheduleMode;
};

export type RoomScheduleMatrix = {
  columns: string[];
  rows: number[];
  values: (null | number)[][];
};

export type RoomScheduleRealisticCatalog = Partial<
  Record<RoomScheduleHeatmapKey, Partial<Record<string, RoomScheduleApiItem | RoomScheduleMatrix>>>
>;

export type RoomSchedulesApi = Partial<Record<RoomScheduleHeatmapKey, RoomScheduleApiItem>>;

export type RoomSchedulesState = Record<RoomScheduleHeatmapKey, RoomScheduleHeatmapState>;

export type RoomScheduleSubtab = (typeof ROOM_SCHEDULE_SUBTABS)[number];

export type RoomScheduleUsageHours = {
  usageEndHour: number;
  usageSaturday: boolean;
  usageStartHour: number;
  usageSunday: boolean;
};

export const isRoomScheduleHeatmapKey = (key: string): key is RoomScheduleHeatmapKey =>
  (ROOM_SCHEDULE_HEATMAP_KEYS as readonly string[]).includes(key);

// Previous schedule UI types (target temperature / air exchange). Kept so those files still compile.
export const ROOM_SCHEDULE_TEMPERATURE_PERIODS = ["operatingHours", "nightHours", "nonOperatingDays"] as const;

export type RoomScheduleAirExchangeState = {
  operatingHours: string;
};

export type RoomScheduleTargetTemperatureState = Record<
  RoomScheduleTemperaturePeriodKey,
  RoomScheduleTemperaturePeriod
> & {
  designTemperature: string;
};

export type RoomScheduleTemperaturePeriod = {
  glidingTmax: boolean;
  tMax: string;
  tMin: string;
};

export type RoomScheduleTemperaturePeriodKey = (typeof ROOM_SCHEDULE_TEMPERATURE_PERIODS)[number];
